// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-b9f8746e]{margin:40px 0 0}ul[data-v-b9f8746e]{list-style-type:none;padding:0}li[data-v-b9f8746e]{display:inline-block;margin:0 10px}a[data-v-b9f8746e]{color:#42b983}", ""]);
// Exports
module.exports = exports;
